const styles = {
  buttonBase: {
    p: 2,
    color: "primary.main",
    fontSize: { xs: 12, md: 16 },
  },
};

export default styles;
